// extracted by mini-css-extract-plugin
module.exports = {"projectTitle":"projectTitle_projectTitle__2R2UB","circle":"projectTitle_circle__1tj-P","textSection":"projectTitle_textSection__1orT5","subtitle":"projectTitle_subtitle__1NcNO"};